import React from 'react';
import { Link } from 'react-router-dom';
import koltoztetesImg from '../img/koltoztetes.png';
import '../App.css';

const QUOTE_KOLTOZTES_PATH = '/ajanlat/koltoztetes';

const QUOTE_ITEMS = [
  'felvételi és lerakási cím',
  'emelet / lift információ',
  'a szállítandó tételek mennyisége',
  'nagyobb bútorok hozzávetőleges mérete',
  'szükséges-e rakodási segítség',
  'van-e különösen nehéz vagy érzékeny tétel',
];

function IconTruck() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M6 40h26v12H6V40zM32 40V26h14l10 14v12H32"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle cx="16" cy="52" r="4.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="46" cy="52" r="4.5" stroke="currentColor" strokeWidth="2" />
      <path d="M10 40V34h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function IconMeasure() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect x="18" y="18" width="28" height="28" rx="1" stroke="currentColor" strokeWidth="2" />
      <path
        d="M12 12v10M12 12h10M52 12h-10M52 12v10M52 52v-10M52 52h-10M12 52h10M12 52v-10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function IconHomeCare() {
  return (
    <svg className="svc-icon-rows-svg" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path
        d="M32 14L48 26v20H16V26l16-12z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M24 46V32h16v14" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path
        d="M6 44c2-8 8-12 14-10M58 44c-2-8-8-12-14-10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function KoltoztetesPage() {
  return (
    <main className="svc-page">
      <section className="svc-hero">
        <div className="svc-hero-inner">
          <nav className="svc-breadcrumb-trail" aria-label="Útvonal">
            <Link className="svc-breadcrumb-seg" to="/" state={{ scrollTo: 'szolgaltatas' }}>
              Szolgáltatások
            </Link>
            <span className="svc-breadcrumb-sep" aria-hidden="true">
              /
            </span>
            <span className="svc-breadcrumb-current" aria-current="page">
              Költöztetés
            </span>
          </nav>

          <div className="svc-hero-grid">
            <div className="svc-hero-text">
              <h1>Költöztetés belföldön és nemzetközi viszonylatban</h1>
              <p>
                Bútorok, dobozok és egyéb ingóságok szállítása belföldön és EU-n belül, komplett vagy
                részrakományos megoldással.
              </p>
              <Link className="primary-btn svc-hero-cta" to={QUOTE_KOLTOZTES_PATH}>
                Ajánlatot kérek
              </Link>
            </div>

            <div className="svc-hero-media">
              <img src={koltoztetesImg} alt="Költöztetés – dobozok, bútorok" />
            </div>
          </div>
        </div>
      </section>

      <section className="svc-band svc-band--cream svc-icon-rows-wrap" aria-label="Gyakorlati információk">
        <div className="svc-band-inner svc-icon-rows-inner">
          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconTruck />
            </div>
            <p className="svc-icon-row-text">
              3,5 t ponyvás <strong>furgonokkal rendelkezünk</strong>, amelynek a befogadó képessége
              18–20 m³ és a maximális terhelhetősége 1000 kg. Természetesen részrakományként is
              tudunk szállítani, ebben az esetben más szállítmányok is kerülnek a te szállítmányod
              mellé.
            </p>
          </div>
          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconMeasure />
            </div>
            <p className="svc-icon-row-text">
              Fontos, hogy a szállítandó termékeid{' '}
              <strong>mennyiségét, méretét és súlyát</strong> a lehető legpontosabban add meg.
              Ajánlatkérésben ezt a „Küldemény listája, és részletes leírása” mezőben tudod megadni.
              Illetve van lehetőséged fényképet vagy fájlt csatolni is a küldeményedről.
            </p>
          </div>
          <div className="svc-icon-row">
            <div className="svc-icon-row-icon" aria-hidden="true">
              <IconHomeCare />
            </div>
            <p className="svc-icon-row-text">
              A normál szállítást <strong>első zárt ajtóig/kapuig</strong> vállaljuk. Van lehetőség
              az „In-home szolgáltatásra”, ahol a sofőr segít a rakodásban, a lakásba vagy akár az
              emeletre való bevitelben. Kérlek vedd figyelembe, hogy a sofőr egyedül közlekedik
              ezért nagyobb, terjedelmes termékek esetén szükség van neki segítségre.
            </p>
          </div>
        </div>
      </section>

      <section className="svc-band svc-band--quote" aria-labelledby="kolto-quote-h">
        <div className="svc-band-inner svc-quote-layout">
          <div className="svc-quote-main">
            <h2 id="kolto-quote-h">Mi alapján készül az ajánlat?</h2>
            <p className="svc-quote-lead">A pontos ajánlathoz kérjük add meg:</p>
            <ul className="svc-bullet-list svc-bullet-list--quote">
              {QUOTE_ITEMS.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
            <p className="svc-tip svc-tip--in-card">
              Ha tudsz, csatolj képet is, így gyorsabban és pontosabban tudunk ajánlatot adni.
            </p>
          </div>

          <aside className="svc-quote-aside" aria-labelledby="kolto-quote-info-h">
            <h2 id="kolto-quote-info-h" className="svc-quote-aside-title">
              Információk:
            </h2>
            <ul className="svc-quote-info-list">
              <li>
                Kérünk, hogy a pontos árajánlathoz <strong>minden mezőt tölts ki</strong> a valóságnak
                megfelelően!
              </li>
              <li>
                A <strong>csillaggal jelölt mezők</strong> kitöltése kötelező.
              </li>
              <li>
                Áraink <strong>nettó árak</strong>. Az Áfát nem tartalmazzák!
              </li>
              <li>
                Az árajánlat elküldését követően <strong>1–5 napon belül</strong> tudjuk a pontos
                árajánlatot kiküldeni.
              </li>
            </ul>
          </aside>
        </div>
      </section>

      <section className="svc-band svc-band--dark">
        <div className="svc-band-inner svc-closing">
          <h2>Költözés előtt állsz?</h2>
          <p>Küldd el a fő adatokat, és készítünk egy személyre szabott ajánlatot.</p>
          <Link className="primary-btn svc-closing-btn" to={QUOTE_KOLTOZTES_PATH}>
            Ajánlatot kérek
          </Link>
        </div>
      </section>

      <section className="svc-band svc-band--white svc-gyik-band">
        <div className="svc-band-inner svc-gyik-row">
          <p className="svc-gyik-text">
            Ha valami kérdésed maradt még, email vagy telefon előtt keresd a GYIK-ben.
            <br />
            Biztos rátalálsz a válaszra.
          </p>
          <Link className="svc-gyik-link" to="/gyik">
            Tovább a GYIK-hez →
          </Link>
        </div>
      </section>
    </main>
  );
}
